import type { FunctionComponent } from 'react';
import Helmet from 'react-helmet';

import {
  DEFAULT_SEPARATOR,
  DEFAULT_TITLE_MIDDLE,
  DEFAULT_TITLE_PREFIX,
} from 'components/shared/PageTitle/constants';

export interface PageTitleProps {
  titlePrefix?: string;
  titleMiddle?: string;
  seperator?: string;
  children?: string;
}

const PageTitle: FunctionComponent<PageTitleProps> = function ({
  titlePrefix = DEFAULT_TITLE_PREFIX,
  titleMiddle = DEFAULT_TITLE_MIDDLE,
  seperator = DEFAULT_SEPARATOR,
  children = '',
}) {
  const string = [titlePrefix, titleMiddle, children]
    .filter(Boolean)
    .join(` ${seperator} `);
  return (
    <Helmet>
      <title>{string}</title>
    </Helmet>
  );
};

export default PageTitle;
